// Antd
import { Grid, Row, Col, Pagination } from 'antd'

// Base Components
import { BaseLabel } from 'components'

// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { IBaseTableFooterProps } from '../interfaces'

const BaseTableFooter = ({ loading, data, onChange }: IBaseTableFooterProps) => {
  // Translate
  const { t } = useTranslation()

  // Breakpoint
  const screens = Grid.useBreakpoint()

  // Common State
  const currentPage = data.currentPage === 0 ? data.currentPage + 1 : data.currentPage || 0
  const pageSize = data.pageSize || 0
  const totalData = data.totalData || 0
  const of = currentPage * pageSize <= totalData ? currentPage * pageSize : totalData
  const offset = (currentPage - 1) * pageSize + 1

  /**
   * @description Watch any change in pagination
   *
   * @param {number} page
   *
   * @return {void} void
   */
  const onChangePage = (page: number): void => {
    onChange({ name: 'pageNumber', value: page })
  }

  return data.list.length !== 0 ? (
    <Row className="mt-4 lg:mt-8" justify="space-between" align="middle">
      <Col
        xs={24}
        sm={24}
        md={6}
        xl={6}
        style={{
          display: 'flex flex-col',
          justifyContent: screens.xs ? 'center' : 'start',
        }}
      >
        <BaseLabel label={`${t('app.page')} ${currentPage} ${t('app.of')} ${data.totalPage}`} fontSize={12} />
        <BaseLabel
          label={`${t('app.showing')} ${offset} ${t('app.to')} ${of} ${t('app.of')} ${data.totalData} Total ${t('app.entries')}`}
          fontSize={12}
        />
      </Col>
      <Col
        xs={24}
        sm={24}
        md={18}
        xl={18}
        style={{
          display: 'flex',
          justifyContent: screens.xs ? 'center' : 'end',
        }}
      >
        <Pagination
          onChange={onChangePage}
          defaultCurrent={currentPage}
          current={currentPage}
          total={data.totalData || 0}
          showQuickJumper={false}
          showSizeChanger={false}
          disabled={loading}
        />
      </Col>
    </Row>
  ) : (
    <></>
  )
}

export { BaseTableFooter }
